import { EditCardFormFields } from '@anm/components/subscription/EditCardForm';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  subscriptionActions,
  subscriptionSelectors
} from '../../../../store/modules/subscription';

const useEditCreditCardPending = () => {
  const isUpdateCardPending = useSelector(
    subscriptionSelectors.selectUpdateCardPending
  );
  const isStripeTokenPending = useSelector(
    subscriptionSelectors.selectStripeTokenPending
  );

  return isUpdateCardPending || isStripeTokenPending;
};

const useSubmitCardHandler = () => {
  const dispatch = useDispatch();
  const isEditCreditCardPending = useEditCreditCardPending();

  const handleEditCreditCard = useCallback(
    ({ expiry_month, expiry_year, ...otherProps }: EditCardFormFields) => {
      dispatch(
        subscriptionActions.editCreditCard({
          stripe: {
            ...otherProps,
            exp_month: expiry_month,
            exp_year: expiry_year
          }
        })
      );
    },
    []
  );

  return [handleEditCreditCard, isEditCreditCardPending] as const;
};

export default useSubmitCardHandler;
